
//import axios from 'axios'
import jsonp from 'jsonp'
import config from 'react-observable-store'

/**
* Geoserver model
*
* Responsible to comunicate with remote server
* @type {String}
*/
const Geoserver = {

    /**
    * Server endpoint
    * @type {String}
    */
    endpoint: () => {
        return config.get('globals').geoserver.endpoint
    },

    /**
     * Query WFS for layer features by lon lat
     * @param  {[type]}   layer [description]
     * @param  {[type]}   lon   [description]
     * @param  {[type]}   lat   [description]
     * @param  {Function} cb    [description]
     * @return {[type]}         [description]
     */
    wfsGetFeaturesByLayerLonLat: (layer, lon, lat, cb) => {
        var params = [
            'viewparams=x:' + lon + ';y:' + lat,
            'service=WFS',
            'version=1.0.0',
            'request=GetFeature',
            'typeName=' + layer,
            'maxFeatures=50',
            'outputFormat=text%2Fjavascript'
        ];

        return jsonp(Geoserver.endpoint() + params.join('&'), {name :'parseResponse'},  (err, data) => {
            if (err) {
                cb({});
            } else {
                data.totalFeatures > 0 ? cb(data.features[0].properties)  : cb({})
            }
        });
    }

}

export default Geoserver



// WEBPACK FOOTER //
// ./src/models/Geoserver.js